module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAATRJREFUWEftV7FKA0EQfQ8sLFKksEghGIigbbDxDyzFLk2+Ib+QwtZPSJdeG//DMoUfkA8I2AjPmzALy3F6Diy5ZgeOveN2Z968hTczxMDGgePjJAAknQGYArgCcO3PnuRLMQCSzt3xzIOlQLZacAOR2xvJpxAASWMAtwB2AO6adZFldBm8zm4AksyRZZGQ55kYALM5gMfmZR0M2s2ApNcsE6Oyz4oDUF/E1v8KoDJQGagMFGdgFRSirSvnffBcvv2T5PuxGHmRifg6eHX7j2z/5veb5CEBqFJcGagMVAYGZ+ALQETVytYCl+O8Hbfe34aJ1JqndjzJankAfxUCSRcO6MZBbQA8NPXgGcAkUkSyvfHJqCuQpJHPfG3W7NtYbY9kyU0ZAD3MpaHUmMuv1K72g+TyB5BssCHenUkHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/windows-2.png
// module id = BGlo
// module chunks = 1